import type React from "react";

import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { BaseButton } from "shared/atoms/BaseButton";
import { MUIUnifiedModal } from "shared/atoms/MUIUnifiedModal";
import { Notification } from "shared/atoms/Notification";

export type Dialog = {
  id: number | null;
  show: boolean;
  status: "accepted" | "discarded" | null;
};

export const initialDialogState: Dialog = {
  id: null,
  show: false,
  status: null,
};

interface Props {
  children?: React.ReactNode;
  error?: string | null;
  isLoading?: boolean;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  status: "accepted" | "discarded";
}

export const ActivityLogConfirmDialog: React.FC<Props> = ({
  children,
  error = null,
  isLoading = false,
  isOpen,
  onCancel,
  onConfirm,
  status,
}) => {
  const { t } = useTranslation();

  return (
    <MUIUnifiedModal
      open={isOpen}
      onClose={onCancel}
      width="430px"
      title={
        status === "accepted"
          ? t("patients.activity_log.form.mark_as_accepted")
          : t("patients.activity_log.form.mark_as_discarded")
      }
    >
      <Stack alignItems="center" p={2} textAlign="center" boxSizing="border-box" spacing={2}>
        {children && (
          <Box width="100%" boxSizing="border-box">
            {children}
          </Box>
        )}
        <BaseButton text={t("buttons.yes")} onClick={onConfirm} disabled={isLoading} loading={isLoading} />
        <BaseButton text={t("buttons.cancel")} onClick={onCancel} disabled={isLoading} variant="tertiaryBlue" />
        {error && <Notification variant="danger">{error}</Notification>}
      </Stack>
    </MUIUnifiedModal>
  );
};
